var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { ExpandableSection, Title } from '@patternfly/react-core';
import { createUseStyles } from 'react-jss';
import ErrorState from '../ErrorState';
import ErrorStack from '../ErrorStack';
const useStyles = createUseStyles({
    expandableSectionToggle: {
        "& > .pf-v6-c-expandable-section__toggle": {
            margin: "auto",
        }
    },
});
export const ErrorBoundary = (_a) => {
    var { headerTitleHeadingLevel = "h1", errorTitleHeadingLevel = "h2" } = _a, props = __rest(_a, ["headerTitleHeadingLevel", "errorTitleHeadingLevel"]);
    const classes = useStyles();
    return (React.createElement(ErrorBoundaryContent, Object.assign({ classes: classes, headerTitleHeadingLevel: headerTitleHeadingLevel, errorTitleHeadingLevel: errorTitleHeadingLevel }, props)));
};
// As of time of writing, React only supports error boundaries in class components
class ErrorBoundaryContent extends React.Component {
    constructor(props) {
        super(props);
        this.updateState = () => {
            if (this.state.historyState !== history.state) {
                this.setState({
                    hasError: false,
                    historyState: history.state,
                });
            }
        };
        this.state = {
            hasError: false,
            historyState: history.state,
        };
    }
    static getDerivedStateFromError(error) {
        return { hasError: true, error, historyState: history.state };
    }
    componentDidUpdate() {
        this.updateState();
    }
    componentDidMount() {
        this.updateState();
    }
    render() {
        const _a = this.props, { ouiaId = 'ErrorBoundary', errorTitleHeadingLevel, headerTitleHeadingLevel } = _a, props = __rest(_a, ["ouiaId", "errorTitleHeadingLevel", "headerTitleHeadingLevel"]);
        if (this.state.hasError) {
            if (this.props.silent) {
                return null;
            }
            return (React.createElement("div", { "data-ouia-component-id": ouiaId },
                (props === null || props === void 0 ? void 0 : props.headerTitle) && React.createElement(Title, { headingLevel: headerTitleHeadingLevel || 'h1', size: "2xl", ouiaId: `${ouiaId}-title` }, props.headerTitle),
                React.createElement(ErrorState, { titleText: props.errorTitle, headingLevel: errorTitleHeadingLevel, bodyText: React.createElement(React.Fragment, null,
                        React.createElement("span", null, props.errorDescription),
                        this.state.error && (React.createElement(ExpandableSection, { className: props.classes.expandableSectionToggle, toggleText: props.errorToggleText ? props.errorToggleText : "Show details", "data-ouia-component-id": `${ouiaId}-toggle` },
                            React.createElement(ErrorStack, { error: this.state.error, "data-ouia-component-id": `${ouiaId}-stack` })))), defaultBodyText: props.defaultErrorDescription })));
        }
        return props.children;
    }
}
;
export default ErrorBoundary;
